<template>
  <div class="items-wrapper">
    <el-tag v-for="(text, index) in props.items" :key="index" closable disable-transitions @close="onItemRemove(index)">
      {{ text }}
    </el-tag>

    <el-tag v-if="props.items && props.items.length" disable-transitions>
      <span style="cursor: pointer" @click="emit('update:items', [])">清空</span>
    </el-tag>
  </div>
</template>

<script setup>
import { ref } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  items: Array
})
// eslint-disable-next-line
const emit = defineEmits(['update:items', 'change'])

function onItemRemove(index) {
  const newItems = props.items.filter((item, i) => i !== index)
  emit('update:items', newItems)
  emit('change', newItems)
}
</script>

<style lang="scss" scoped>
.items-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .el-tag {
    margin-right: 10px;
    margin-bottom: 4px;
  }
}
</style>
